<template>
	<div class="form-group row">
		<label :for="label" class="col-sm-3 col-form-label">{{formatTitle(label)}}</label>
		<div class="col-sm-9">
			<textarea class="form-control" :id="label" :value="value" v-on:change="$emit('change', $event.target.value)">
			</textarea>
		</div>
	</div>
</template>

<script>
export default {
	model: {
		event: 'change',
	},
	props: [
		'value',
		'label'
	],
	methods: { 
		formatTitle (input) {
			return input.replace('_',' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
		}
	},
}
</script>

<style scoped>

</style>